import {EditInvoices} from './edit-invoices';

export default EditInvoices;
